import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { MenuIcon, XIcon } from 'lucide-react';
export function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  return <nav className="bg-white border-b-4 border-m3-on-surface fixed w-full top-0 z-50" data-id="element-94">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-95">
        <div className="flex justify-between items-center h-24" data-id="element-96">
          <Link to="/" className="flex items-center space-x-3 group" data-id="element-97">
            <motion.img src="https://uploadthingy.s3.us-west-1.amazonaws.com/vdT4rA9mtEjYTkQ7Gc8P9V/snowday_logo_clean.svg" alt="Snow Day Logo" className="w-20 h-20" whileHover={{
            scale: 1.05
          }} transition={{
            type: 'spring',
            stiffness: 400,
            damping: 10
          }} data-id="element-98" />
            <span className="text-3xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-m3-on-surface to-m3-outline uppercase tracking-wider" style={{
            textShadow: '0 0 10px rgba(13,112,128,0.2)'
          }} data-id="element-99">
              Snow Day
            </span>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-6" data-id="element-100">
            <Link to="/" className="text-m3-on-surface hover:text-m3-outline transition-colors font-bold uppercase text-sm tracking-wider hover:scale-110 transform duration-200" data-id="element-101">
              Home
            </Link>
            <Link to="/contact" className="text-m3-on-surface hover:text-m3-outline transition-colors font-bold uppercase text-sm tracking-wider hover:scale-110 transform duration-200" data-id="element-102">
              Contact
            </Link>
            <motion.a href="https://app.snowdayacademy.com" className="bg-gradient-to-b from-word-current to-word-error-light text-word-error px-6 py-3 pixel-corners border-4 border-m3-outline font-bold uppercase text-sm tracking-wider shadow-[0_4px_0_0_#45300F] hover:shadow-[0_2px_0_0_#45300F] hover:translate-y-[2px] transition-all" whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} data-id="element-103">
              Try it Now
            </motion.a>
          </div>

          {/* Mobile menu button */}
          <motion.button onClick={() => setIsOpen(!isOpen)} className="md:hidden p-3 pixel-corners border-2 border-m3-on-surface bg-white text-m3-on-surface hover:bg-m3-on-surface hover:text-white transition-colors" whileTap={{
          scale: 0.9
        }} data-id="element-104">
            {isOpen ? <XIcon className="w-6 h-6" data-id="element-105" /> : <MenuIcon className="w-6 h-6" data-id="element-106" />}
          </motion.button>
        </div>
      </div>

      {/* Mobile Navigation */}
      <AnimatePresence data-id="element-107">
        {isOpen && <motion.div className="md:hidden bg-m3-surface border-t-4 border-m3-on-surface" initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3
      }} data-id="element-108">
            <div className="px-4 py-6 space-y-4" data-id="element-109">
              <Link to="/" className="block px-6 py-3 text-m3-on-surface hover:bg-m3-on-surface hover:text-white pixel-corners border-2 border-m3-on-surface transition-colors font-bold uppercase text-sm tracking-wider text-center" onClick={() => setIsOpen(false)} data-id="element-110">
                Home
              </Link>
              <Link to="/contact" className="block px-6 py-3 text-m3-on-surface hover:bg-m3-on-surface hover:text-white pixel-corners border-2 border-m3-on-surface transition-colors font-bold uppercase text-sm tracking-wider text-center" onClick={() => setIsOpen(false)} data-id="element-111">
                Contact
              </Link>
              <a href="https://app.snowdayacademy.com" className="block text-center bg-gradient-to-b from-word-current to-word-error-light text-word-error px-6 py-4 pixel-corners border-4 border-m3-outline font-bold uppercase text-sm tracking-wider" onClick={() => setIsOpen(false)} data-id="element-112">
                Try it Now
              </a>
            </div>
          </motion.div>}
      </AnimatePresence>
    </nav>;
}